import * as React from 'react';
export const chevronUpCircleSvg = React.forwardRef(
  function chevronUpCircleSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M12.28 9.78a.75.75 0 0 1-1.06 0L8 6.56 4.78 9.78a.75.75 0 0 1-1.06-1.06l3.75-3.75a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1 0 1.06Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M8 1.5A6.5 6.5 0 0 0 1.5 8c0 3.592 2.9 6.5 6.5 6.5A6.5 6.5 0 0 0 14.5 8 6.5 6.5 0 0 0 8 1.5ZM8 0a8 8 0 0 0-8 8c0 4.419 3.57 8 8 8a8 8 0 0 0 8-8 8 8 0 0 0-8-8Z',
      }),
    );
  },
);
chevronUpCircleSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronUpCircle = {
  category: 'icon',
  colorable: true,
  name: 'chevronUpCircle',
  svg: chevronUpCircleSvg,
};
